module.exports = __webpack_public_path__ + "static/img/areaA-17.06c7c85.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/areaA-17.png
// module id = 928
// module chunks = 1